<template>
	<div>
		<modal
			class="macro-modal"
			size="medium"
			:hide-footer="true"
			@close="close">
			<template slot="header">
				<span>{{ $t('Macro Item') }}</span>
			</template>
			<template slot="body">
				<div class="d-flex align-items-end">
					<div class="macro-name form-group mb-0 mr-2">
						<label class="label">{{ $t('Rundown Asset') }}</label>
						<md-menu
							class="h-fc w-100"
							md-size="small"
							md-direction="bottom-start"
							md-align-trigger>
							<div v-if="selectedItem"
								class="form-control cur-p relative"
								md-menu-trigger>
								<item-option
									:item="selectedItem"
									v-if="selectedItem"
								/>
								<div @click="selectedItem = null" class="modal-close absolute pt-2 delete-macro-add">
									<i class="material-icons">cancel</i>
								</div>
							</div>
							<div v-else md-menu-trigger>
								<input
									type="text"
									class="form-control"
									:placeholder="$t('Search')"
									@input="onKeywordChange"
									v-model="keyword"
								/>
								<item-option
									:item="selectedItem"
									v-if="selectedItem"
								/>
							</div>
							<md-menu-content class="macro-content-wrapper-list" id="scrolls-style">
								<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
									@click="selectRundownCommand()">
									<i class="material-icons md-18 p-0 h-fc">playlist_play</i><span class="absolute ml-5 pl-1">Rundown Command</span>
								</md-menu-item>
								<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
									v-for="rundownItem in availableRundownItems"
									:key="rundownItem.id"
									@click="selectItem(rundownItem)">
									<item-option :item="rundownItem" />
								</md-menu-item>
								<md-menu-item v-if="availableRundownItems.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
									Oops, there is no assets available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
					<!-- if not rundown -->
					<div class="macro-action form-group mb-0 mr-2">
						<label class="label">{{ $t('Action') }}</label>
						<md-menu
							class="h-fc w-100"
							md-size="small"
							md-direction="bottom-start"
							md-align-trigger>
							<div
								class="form-control cur-p"
								md-menu-trigger>
								<div
									v-if="selectedAction">
									{{ $t(selectedAction.label) }}
								</div>
								<div v-else>{{ $t('None') }}</div>
							</div>
							<md-menu-content>
								<md-menu-item class="item-macros-action"
									@click="selectAction(action)"
									v-for="action in actions"
									:key="action.key">
									{{ $t(action.label) }}
								</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
					<!-- delay macro -->
					<div class="macro-action form-group mb-0 pr-2">
						<label class="label">{{ $t('Delay') }}(ms)</label>
						<custom-input
							type="number"
							class="form-control pl-4"
							:min="0"
							:max="60000"
							:step="100"
							v-model="delay"
						/>
					</div>
					<div class="macro-add">
						<button
							type="button"
							class="btn btn-icon btn-primary mr-0 w-100"
							:class="{ 'is-loading': isAddingItem }"
							:disabled="!selectedItem || !selectedAction"
							@click="addItem">
							{{ $t('Add') }}
						</button>
					</div>
				</div>
				<div class="macro-content">
					<div class="form-group mb-3 mt-2">
						<label class="label mb-0">{{ $t('Please select the asset, select the action and click ADD button') }}</label>
					</div>
					<div class="form-group mb-1">
						<label class="label mb-0">{{ $t('Macro items will be called sequentially - delay is relative previous item') }}</label>
					</div>
					<hr class="m-0">
					<table class="table table-small table-hover mb-0">
						<thead>
							<tr>
								<th width="40%">{{ $t('Item') }}</th>
								<th width="14%">{{ $t('Index') }}</th>
								<th width="18%">{{ $t('Action') }}</th>
								<th width="20%">{{ $t('Delay') }}</th>
								<th width="20%">{{ $t('') }}</th>
							</tr>
						</thead>
					</table>
					<div v-if="items.length === 0" class="text-center absolute pt-18">
						{{$t('No macro items available')}}
					</div>
					<!-- list item in above -->
						<div class="macro-list-wrapper">
							<draggable
								handle=".handle-macro-list"
								v-model="items"
								v-bind="dragOptions"
								@start="drag = true"
								@end="drag = false"
								@change ="onItemsOrderChanged">
									<transition-group
										type="transition"
										:name="!drag ? 'flip-list' : null">
										<macro-item-row
											v-for="item in items"
											:key="item.id"
											:data="item"
											:rundown-items="availableRundownItems"
											@remove="removeItem"
											@update="updateItem">
										</macro-item-row>
									</transition-group>
							</draggable>
						</div>

					</div>
				<div class="mt-auto macro-bottom">
					<div class="macro-name form-group mb-0 mr-2">
						<label class="label">{{ $t('Macro Name - Will appear in tooltip') }}</label>
					</div>
					<div class="d-flex justify-content-between">
						<input
							type="text"
							class="form-control"
							:placeholder="$t('Name')"
							v-model="name"
						/>
						<!-- <div class="macro-index form-group mb-0 mr-2">
							<label class="label">{{ $t('Macro Index') }}</label>
							<input
								disabled
								type="text"
								class="form-control"
								v-model="data.order"
							/>
						</div> -->
						<div class="mr-2 ml-2">
							<button
								type="button"
								class="btn btn-icon btn-default mr-0"
								@click="save"
								v-tooltip="$t('Save')">
								<i class="material-icons">save</i>
							</button>
						</div>
						<div class="mr-2">
							<button
								type="button"
								class="btn btn-icon btn-default mr-0"
								@click="duplicate"
								v-tooltip="$t('Duplicate Macro')">
								<i class="material-icons">content_copy</i>
							</button>
						</div>
						<div class="mr-2">
							<button
								type="button"
								class="btn btn-icon btn-default mr-0"
								:class="{ 'is-loading': isRemoving }"
								@click="isConfirmRemoveVisible = true"
								v-tooltip="$t('Delete Macro')">
								<i class="material-icons">delete</i>
							</button>
						</div>
					</div>
				</div>
				<!-- Delete Confirmation -->
			</template>
		</modal>
		<modal
			size="small"
			@close="isConfirmRemoveVisible = false"
			v-if="isConfirmRemoveVisible">
			<template slot="header">
				{{ $t('Remove Macro') }}
			</template>
			<template slot="body">
				{{ $t('Are you sure want to delete') }} {{ data.name }}?
			</template>
			<template slot="footer">
				<div class="w-100 flex-center">
					<button
						class="btn btn-primary"
						:class="{ 'is-loading': isRemoving }"
						@click="remove">
						{{ $t('Remove') }}
					</button>
					<button
						class="btn btn-default"
						@click="isConfirmRemoveVisible = false">
						{{ $t('Cancel') }}
					</button>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import { macroItemActions, macroItemActionsCustom } from '@/lib/statics';
import { duplicateVar, delay } from '@/lib/helper';
import CustomInput from '@/components/CustomInput.vue';
import macrosApi from '@/api/macros';
import macroItemsApi from '@/api/macro-items';
import Modal from '@/components/Modal.vue';
import ItemOption from '@/components/ItemOption.vue';
import MacroItemRow from '@/components/MacroItemRow.vue';

export default {
	name: 'MacroModal',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		rundownItems: {
			type: Array,
			default: () => [],
		},
		macros: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		Modal,
		ItemOption,
		MacroItemRow,
		draggable,
		CustomInput,
	},
	data() {
		return {
			name: '',
			index: '1',
			shortcut: '',
			status: '',
			selectedItem: null,
			selectedAction: null,
			isSaving: false,
			isRemoving: false,
			isAddingItem: false,
			isFetchingItems: false,
			items: [],
			item: null,
			itemAction: null,
			dragOptions: {
				animation: 100,
			},
			drag: false,
			keyword: '',
			// custom command
			paramsCustomCommand: {},
			isAddingItemCustom: false,
			customCommand: '',
			isConfirmRemoveVisible: false,
			delay: 0,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		reset() {
			this.name = '';
			this.index = '1';
			this.shortcut = '';
			this.status = '';
		},
		setData() {
			this.name = this.data.name;
		},
		initData() {
			this.reset();
			if (this.data) {
				this.setData();
				this.fetchItems();
			}
		},
		save() {
			this.isSaving = true;
			const callback = (response) => {
				const macro = response.data;
				this.$emit('save', macro);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			if (this.isAdd) {
				macrosApi.create(this.params, callback, errorCallback);
			} else {
				macrosApi.update(this.data.id, this.params, callback, errorCallback);
			}
		},
		remove() {
			this.isRemoving = true;
			const callback = () => {
				this.$emit('remove', this.data);
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
			};
			const errorCallback = () => {
				this.isRemoving = false;
			};
			macrosApi.delete(this.data.id, callback, errorCallback);
		},
		fetchItems() {
			this.isFetchingItems = true;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'order',
				sort_by: 'asc',
				macro_id: this.data.id,
			};
			const callback = (response) => {
				const items = response.data;
				this.items = items;
				this.isFetchingItems = false;
			};
			const errorCallback = () => {
				this.isFetchingItems = false;
			};
			macroItemsApi.getList(params, callback, errorCallback);
		},
		addItem() {
			this.isAddingItem = true;
			const action = this.selectedAction ? this.selectedAction.key : 'play';
			const params = {
				macro_id: this.data.id,
				rundown_id: this.rundown.id,
				status: action,
				delay: this.delay,
			};
			if (this.selectedItem.id) params.rundown_item_id = this.selectedItem.id;
			const callback = (response) => {
				const item = response.data;
				this.items.push(item);
				this.$emit('update', this.items);
				this.isAddingItem = false;
				this.selectedItem = null;
				this.selectedAction = null;
				this.delay = 0;
			};
			const errorCallback = () => {
				this.isAddingItem = false;
			};
			macroItemsApi.create(params, callback, errorCallback);
		},
		removeItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index !== -1) {
				this.items.splice(index, 1);
				if (this.items.length > 0) {
					this.$emit('update', this.items);
				} else {
					this.$emit('update', this.items[index]);
				}
			}
		},
		updateItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index !== -1) {
				this.$set(this.items, index, item);
				this.$emit('update', this.items);
			} else {
				this.items.push(item);
				this.$emit('update', this.items);
			}
		},
		selectItem(item) {
			this.selectedItem = item;
		},
		selectRundownCommand() {
			const item = {
				name: 'Rundown Command',
				type: 'rundown',
			};
			this.selectedItem = item;
		},
		selectAction(action) {
			this.selectedAction = action;
		},
		onItemsOrderChanged() {
			const ids = this.items.map(({ id }) => id);
			const callback = () => {
				this.$emit('update', this.items);
			};
			const errorCallback = () => {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Macros',
					text: 'Error when reordering macro',
				});
			};
			macroItemsApi.reorder(ids, callback, errorCallback);
		},
		duplicate() {
			this.isDuplicating = true;
			const name = `${this.$t('Duplicate of')} ${this.name}`;
			const params = {
				name,
				rundown_id: this.rundownId,
			};
			const callback = (response) => {
				const macro = response.data;
				const msg = response.message;
				// Duplicate Items
				this.duplicateItems(macro);
				// this.$emit('duplicate', macro);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Macros',
					text: msg,
				});
			};
			const errorCallback = () => {
				this.isDuplicating = false;
			};
			if (this.macros.length < 14) {
				macrosApi.create(params, callback, errorCallback);
			} else {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Macros',
					text: 'You have reach the Limit (14 Macros)',
				});
			}
		},
		duplicateItems(macro) {
			const itemsLength = this.items.length;
			let counter = itemsLength;
			const callback = () => {
				counter--;
				if (counter === 0) {
					this.$emit('duplicate', macro);
				}
			};
			const errorCallback = () => {
			};
			for (let index = 0; index < itemsLength; index++) {
				const item = this.items[index];
				const params = {
					macro_id: macro.id,
					rundown_id: item.rundown_id,
					status: item.status,
				};
				if (item.rundown_item_id) params.rundown_item_id = item.rundownItem.id;
				macroItemsApi.create(params, callback, errorCallback);
			}
		},
		onKeywordChange() {
			delay(() => {
				this.$emit('fetch', this.keyword);
			}, 200);
		},
		// custom command
		selectCustomCommand(command) {
			if (command === 'clear_output') {
				this.customCommand = 'clear_output';
				this.paramsCustomCommand = {
					macro_id: this.data.id,
					rundown_id: this.rundown.id,
					status: 'clear_output',
				};
			} else {
				this.customCommand = 'stop_all';
				this.paramsCustomCommand = {
					macro_id: this.data.id,
					rundown_id: this.rundown.id,
					status: 'stop_all',
				};
			}
		},
		addCustomCommand() {
			this.isAddingItemCustom = true;
			const callback = (response) => {
				const item = response.data;
				this.items.push(item);
				this.isAddingItemCustom = false;
				this.customCommand = '';
			};
			const errorCallback = () => {
				this.isAddingItemCustom = false;
			};
			macroItemsApi.create(this.paramsCustomCommand, callback, errorCallback);
		},
	},
	computed: {
		isAdd() {
			return !this.data;
		},
		isEdit() {
			return !!this.data;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		params() {
			const name = this.name.trim();
			const params = {
				name,
				index: this.index,
				shortcut: this.shortcut,
				status: this.status,
			};
			return params;
		},
		availableRundownItems() {
			const filter = (({ id }) => {
				const isPicked = this.items.findIndex(item => item.rundownItem && item.rundownItem.id === id) !== -1;
				return !isPicked;
			});
			return this.rundownItems.filter(filter);
		},
		actions() {
			// eslint-disable-next-line
			let actionsResult = '';
			if (this.selectedItem && this.selectedItem.type === 'rundown') {
				// eslint-disable-next-line
				return actionsResult = duplicateVar(macroItemActionsCustom);
				// eslint-disable-next-line
			} else {
				// eslint-disable-next-line
				return actionsResult = duplicateVar(macroItemActions);
			}
		},
	},
	watch: {
		data() {
			this.initData();
		},
	},
	created() {
		this.initData();
	},
};
</script>
<style>
.material-icons-close-macro {
	cursor: pointer;
	margin-right: 5px;
	padding-right: 20px;
	font-weight: normal;
	font-style: normal;
	font-size: 12px;
	color: #FFA800;
	line-height: 1;
	text-transform: capitalize;
	display: block;
	white-space: nowrap;
	word-wrap: normal;
	direction: rtl;
	position: absolute;
	left: 0;
	top: 25%;
}
</style>
